import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { ProductHomepageService } from '@shared/services/product-homepage.service';
import { LanguageService } from '@shared/shared/services/language-service';
import { Angulartics2Segment } from 'angulartics2';
import { Observable } from 'rxjs';

export interface EligibilityResultDialogData {
  tracking?: string;
  continueTracking?: string;
  type: 'invalid' | 'success';
  subtitle: string;
  translations: string[];
  customVarParagraph: string[];
}

@Component({
  selector: 'ten-eligibility-result-dialog',
  templateUrl: './eligibility-result-dialog.component.html',
  styleUrls: ['./eligibility-result-dialog.component.scss'],
  standalone: true,
  imports: [NgClass, AsyncPipe, MatIconModule, TranslateModule, NgIf, NgFor, MatDialogModule, MatLegacyButtonModule],
})
export class EligibilityResultDialogComponent {
  public rightToLeftSite: boolean;
  public customVariables$: Observable<CustomisableVariables> = this.customVariableService.variables;

  constructor(
    public dialogRef: MatDialogRef<EligibilityResultDialogComponent>,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: EligibilityResultDialogData,
    private customVariableService: CustomisableVariablesService,
    private productHomepageService: ProductHomepageService,
    private angulartics2Segment: Angulartics2Segment
  ) {
    this.rightToLeftSite = this.languageService.isRtlLanguage();

    if (this.data.tracking) {
      this.angulartics2Segment.eventTrack(this.data.tracking, {});
    }
  }

  public onCrossClick() {
    this.dialogRef.close();
  }

  public onRegister() {
    if (this.data.continueTracking) {
      this.angulartics2Segment.eventTrack(this.data.continueTracking, {});
    }

    this.dialogRef.close();
    this.productHomepageService.navigateToRegistration();
  }
}
